import * as React from 'react';
import {Link} from 'react-router-dom';
import {addTherapySessions, getEsignProfiles, getTemplates, getUsers} from "../../../api";
import {useEffect, useState} from "react";
import {AppUser, Template} from "../../../types";
import {useHistory} from "react-router";
import dateFormat from "dateformat";

const dateParse = require('date-format');


const AddTherapySession: React.FunctionComponent = () => {

    const [therapist, setTherapist] = useState("");
    const [date, setDate] = useState("");
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [users, setUsers] = useState<AppUser[]>();
    const [doRedirectToSearch, setDoRedirectToSearch] = useState(false);
    const history = useHistory();
    const [templates, setTemplates] = useState<Template[]>();
    const [profile, setProfile] = useState("");
    const [note, setNote] = useState("");

    useEffect(() => {
        if (startTime !== undefined && startTime !== "") {
            try {
                const parse = dateParse.parse("hh:mm", startTime);
                const calcEndTime = parse.setHours(parse.getHours() + 3);
                setEndTime(dateFormat(calcEndTime, "HH:MM"));
            } catch (e) {

            }
        }
    }, [startTime]);

    useEffect(() => {
        getEsignProfiles()
            .then((ps) => {
                let profile = ps.filter((p) => p.name === "Promises12")[0];
                setProfile(profile.uuid);
                getTemplates(profile.uuid)
                    .then((tz) => {
                        setTemplates(tz.filter((t) => t.tag === "note"));
                    })
            })
            .catch((e) => {
                console.error(e);
            })
    }, []);

    const doAdd = () => {
        addTherapySessions({
            therapist: {
                uuid: therapist
            },
            date: date,
            endTime: endTime,
            startTime: startTime,
            noteUuid: note
        })
            .then((t) => {
                setDoRedirectToSearch(true);
            })
            .catch((e) => console.log(e));


    }

    useEffect(() => {
        if (doRedirectToSearch) {
            history.push({
                pathname: "/m/therapy-sessions"
            });
        }
    }, [doRedirectToSearch, history]);

    useEffect(() => {
        getUsers()
            .then((uz) => {
                setUsers(uz);
            })
            .catch((e) => console.log(e))
            .finally(() => {
            })


    }, []);

    return (<>
        <div className={"row"}>
            <div className={"col-lg-12 mb-3 "}>
                <h2>Add Therapy Session</h2>
            </div>
            <form onSubmit={(e) => {
                e.preventDefault();
                doAdd();
            }}>
                <div className={"col-lg-12 mb-3 "}>

                    <div className="form-row align-items-center">
                        <div className="col-sm-6 my-1">
                            <label htmlFor="inputEmail4">Therapist</label>
                            <select required={true} id="inputState" className="form-control"
                                    onChange={(e) => setTherapist(e.target.value)}>
                                <option key={"u_0"} value={""}>Select a therapist...</option>
                                {
                                    users?.map((u) => (
                                        <option key={u.uuid} value={u.uuid}>{u.lastName + ", " + u.firstName}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="col-sm-6 my-1">
                            <label htmlFor="inputEmail4">Date</label>
                            <input required={true} type="date" className="form-control" id="inlineFormInputName"
                                   value={date} onChange={(e) => {
                                setDate(e.target.value)
                            }}
                            />
                        </div>
                        <div className="col-sm-6 my-1">
                            <label htmlFor="inputEmail4">Start Time</label>
                            <input required={true} type="time" className="form-control" id="inlineFormInputName"
                                   value={startTime} onChange={(e) => {
                                setStartTime(e.target.value)
                            }}
                            />
                        </div>
                        <div className="col-sm-6 my-1">
                            <label htmlFor="inputEmail4">End Time</label>
                            <input required={true} type="time" className="form-control" id="inlineFormInputName"
                                   value={endTime} onChange={(e) => {
                                setEndTime(e.target.value)
                            }}
                            />
                        </div>
                        <div className="col-sm-6 my-1">
                            <label htmlFor="inputEmail4">Session Type</label>
                            <select className="custom-select" id="inputGroupSelect04"
                                    required={false}
                                    aria-label="Example select with button addon" value={note}
                                    onChange={(e) => setNote(e.target.value)}>
                                <option value={""}>Choose...</option>
                                {
                                    templates?.map((t) => (
                                        <option key={t.uuid} value={t.uuid}>{t.name}</option>
                                    ))
                                }

                            </select>
                        </div>

                    </div>
                </div>

                <div className={"col-lg-12 mb-3 "}>
                    <Link to={"/m/therapy-sessions"}>
                        <button type={"button"} className={"btn btn-danger mr-3"}>
                            Cancel
                        </button>
                    </Link>
                    <button type={"submit"} className={"btn btn-primary"}
                    >
                        Add Therapy Session
                    </button>
                </div>
            </form>
        </div>
    </>);
};

export default AddTherapySession;